const messages = {
  title: "Startseite",
  welcomeMessage:
    'Willkommen bei BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Startseite",
  search: "Suche",
  sortBy: "Sortieren nach",
  seeMore: "Alle anzeigen",
  bankstatement: {
    yourScore: "Ihr aktueller Punktestand:",
    lastUpdate: "Letzte Aktualisierung:",
    link: "Punkteübersicht anzeigen",
  },
  shop: {
    bestSold: "Meistgekauft",
    seasonal: "Saisonales",
    affordable: "Fast geschafft",
    forPoints: "für {points} Punkte",
    reachedPoints: "Benötigten Punktestand erreicht",
    cartRemainPoints: "Punkte verbleibend",
    remainingPoints: "{points} Punkte noch fehlend",
    noProducts: "Die Suchkriterien ergaben keine Treffer",
    variant: "Varianten wählbar",
  },
  showAllProducts: "Zum Prämienshop",
  shopCommingSoon:
    "Das Prämienprogramm<br/><br/><div class='font-25'>Tauschen Sie die Prämienpunkte direkt</div><div class='font-25'>auf der Plattform gegen eine große</div><div class='font-25'>Auswahl an Prämien aus</div><div class='font-25'>verschiedenen Kategorien ein.</div>",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>ist in Kürze wieder verfügbar.</div>",
};

export default {
  messages,
};
